import DriverCell from './container';

export default DriverCell;
